import { sessionStore } from '@bg-shared/business/Session';
import { SortDirection } from '@bg-shared/enums';
import { format } from 'date-fns';
import { sortBy } from '@betgames/bg-tools';
import { IGamificationInbox } from '../interfaces';
import { ICUInbox } from '../services/CaptainUpAPI';

class InboxesFormatter {
    public formatInboxes(inboxes: ICUInbox[]): IGamificationInbox[] {
        return inboxes.map((inbox) => ({
            id: inbox._id,
            title: inbox.entity.title,
            date: format(Date.parse(inbox.timestamp), sessionStore.dateFormat),
            description: inbox.entity.content,
            image: inbox.entity.preset_image,
            timestamp: Date.parse(inbox.timestamp),
            unread: false,
            unseen: false,
        }));
    }

    public mergeInboxes(
        inboxes: IGamificationInbox[],
        unreadInboxes: IGamificationInbox[],
    ): IGamificationInbox[] {
        const inboxIds = inboxes.map((inbox) => inbox.id);

        const { unreadIds, newUnreadInboxes } = unreadInboxes.reduce<{
            unreadIds: string[];
            newUnreadInboxes: IGamificationInbox[];
        }>(
            (acc, inbox) => {
                if (inboxIds.includes(inbox.id)) {
                    acc.unreadIds.push(inbox.id);
                } else {
                    acc.newUnreadInboxes.push({ ...inbox, unread: true, unseen: true });
                }

                return acc;
            },
            {
                unreadIds: [],
                newUnreadInboxes: [],
            },
        );

        const updatedInboxes = inboxes.map((inbox) => {
            if (unreadIds.includes(inbox.id)) {
                return {
                    ...inbox,
                    unread: true,
                    unseen: true,
                };
            }

            return inbox;
        });

        updatedInboxes.unshift(...newUnreadInboxes);

        return updatedInboxes.sort(sortBy((inbox) => inbox.timestamp, SortDirection.DESC));
    }
}

export const inboxesFormatter = new InboxesFormatter();
